import React from 'react';
import { useAuth } from '../../context/AuthContext';
import CustomerDashboard from './CustomerDashboard';
import AgentDashboard from './AgentDashboard';

const Dashboard = () => {
  const { user } = useAuth();

  if (user?.role === 'agent') {
    return <AgentDashboard />;
  }

  return <CustomerDashboard />;
};

export default Dashboard;
